import { primaryGreen, primaryRed } from "@styles/colors";

export const CheckIcon = () => {
  const iconStyle: React.CSSProperties = {
    width: '20px',
    height: '20px',
    backgroundColor: '#d4f7d4',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
  };

  const checkmarkStyle: React.CSSProperties = {
    content: '""',
    width: '11px',
    height: '5px',
    border: `1px solid ${primaryGreen}`,
    borderWidth: '0 0 2px 2px',
    transform: 'rotate(-45deg)',
    position: 'absolute',
    top:'7px'
  };

  return (
    <div style={iconStyle}>
      <div style={checkmarkStyle}></div>
    </div>
  );
};

export const CrossIcon = () => {
  const iconStyle: React.CSSProperties = {
    width: '20px',
    height: '20px',
    backgroundColor: '#f8d7da',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
  };

  const lineStyle: React.CSSProperties = {
    position: 'absolute',
    width: '10px',
    height: '2px',
      backgroundColor: primaryRed,
  };

  const line1: React.CSSProperties = {
    ...lineStyle,
    transform: 'rotate(45deg)',
  };

  const line2 = {
    ...lineStyle,
    transform: 'rotate(-45deg)',
  };

  return (
    <div style={iconStyle}>
      <div style={line1}></div>
      <div style={line2}></div>
    </div>
  );
};

